import { useQuery } from '@tanstack/react-query'
import { useCallback, useState } from 'react'
import { giftSentRankingLiveService } from '../../../../services/lives/lives'

export const LIVE_QUERY_KEY = 'getLive'

export const useGetLivePoints = (liveId: number, enabled = true) => {
  const [params, setParams] = useState<{ liveId: number | null }>({
    liveId,
  })

  const { data, refetch } = useQuery({
    queryKey: [LIVE_QUERY_KEY, params],
    enabled,
    staleTime: 0,
    queryFn: () => {
      return giftSentRankingLiveService.getLivePoints({
        liveId: Number(params?.liveId),
      })
    },
  })

  const get = useCallback(
    (liveId: number) => {
      setParams({ liveId })
    },
    [setParams],
  )

  return {
    live: data?.data,
    refetch,
    get,
  }
}
